import { render, staticRenderFns } from "./addSupplier.vue?vue&type=template&id=2274a87f&scoped=true"
import script from "./addSupplier.vue?vue&type=script&lang=js"
export * from "./addSupplier.vue?vue&type=script&lang=js"
import style0 from "./addSupplier.vue?vue&type=style&index=0&id=2274a87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2274a87f",
  null
  
)

export default component.exports